import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  editor?: object;
  colorTheme?: 'DARK' | 'LIGHT';
  titleSubtitle?: {
    subtitle?: string;
    subtitleColor?: string;
    subtitleColorMobile?: string;
    title?: string;
    titleColor?: string;
    titleColorMobile?: string;
  };
  imageSection?: {
    imageUrl?: string;
    imageAlt?: string;
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'titleSubtitle',
    label: 'Title and Subtitle',
    type: types.OBJECT,
    children: [
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'subtitleColor',
        label: 'Subtitle Color (overrides color theme)',
        type: types.COLOR_PICKER,
      },
      {
        key: 'subtitleColorMobile',
        label: 'Subtitle Color Mobile (overrides subtitle color on mobile)',
        type: types.COLOR_PICKER,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'titleColor',
        label: 'Title Color (overrides color theme)',
        type: types.COLOR_PICKER,
      },
      {
        key: 'titleColorMobile',
        label: 'Title Color Mobile (overrides title color on mobile)',
        type: types.COLOR_PICKER,
      },
    ],
  },
  {
    key: 'imageSection',
    label: 'Image Section',
    type: types.OBJECT,
    children: [
      {
        key: 'imageUrl',
        label: 'Image URL',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'imageAlt',
        label: 'Image Alt Text',
        tooltip: 'This is important for SEO and accessibility. This is not shown on the page.',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'colorTheme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES,
  },
];

export const defaultProps: Props = {
  colorTheme: 'LIGHT',
  titleSubtitle: {
    subtitle: 'Subtitle',
    title: 'Title',
  },
  imageSection: {
    imageUrl: 'https://genesis-cdn.ff.com/FX/717/722_Front_OffRoad_AI_72PPI-default.jpg',
    imageAlt: 'FX Super One and Burj Khalifa',
  },
};

export default {
  title: 'Image With Text in Corner',
  id: 'ImageWithTextInCorner',
  propsSchema,
  defaultProps,
}
